(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      // 2026-07-22 CW_008: PC/SP 別 sticky_header_type 対応 = matchMedia で 判定 → resize 追従
      this.pcMedia = window.matchMedia('(min-width: 750px)');
      this.stickyType = this.getCurrentStickyType();
      this.headerIsAlwaysSticky =
        this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 750px)').addEventListener('change', this.setHeaderHeight.bind(this));
      // 2026-07-22 CW_008: PC/SP 切替時 = sticky_type 再判定 + class 再適用
      this.onBreakpointChangeHandler = this.onBreakpointChange.bind(this);
      this.pcMedia.addEventListener('change', this.onBreakpointChangeHandler);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    /* 2026-07-22 CW_008: 現行 viewport (PC/SP) に応じた sticky_type 取得 = data-sticky-type-pc / data-sticky-type-sp 参照 */
    getCurrentStickyType() {
      const isPC = this.pcMedia.matches;
      const attr = isPC ? 'data-sticky-type-pc' : 'data-sticky-type-sp';
      return this.getAttribute(attr) || this.getAttribute('data-sticky-type') || 'on-scroll-up';
    }

    /* 2026-07-22 CW_008: PC/SP 切替時 = sticky_type 再判定 + class 再適用 */
    onBreakpointChange() {
      this.stickyType = this.getCurrentStickyType();
      this.headerIsAlwaysSticky =
        this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';

      if (this.stickyType === 'none') {
        // none 時 = sticky class 全解除 = 通常フロー
        this.header.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden', 'animate', 'scrolled-past-header');
      } else if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden');
      } else {
        this.header.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden', 'animate');
      }
      // headerBounds も 再計算 (breakpoint change = layout 再構築)
      this.createObserver();
      this.setHeaderHeight();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.pcMedia && this.onBreakpointChangeHandler) {
        this.pcMedia.removeEventListener('change', this.onBreakpointChangeHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // 2026-07-22 CW_008: 現行 viewport の stickyType が 'none' の場合 = 通常フロー = sticky 制御しない
      if (this.stickyType === 'none') {
        this.header.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden', 'animate', 'scrolled-past-header');
        return;
      }
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ------------------------------------------------------------
   * TOP PC ヘッダー透過 → 1 viewport スクロール後 通常デザイン
   *   対象: body 内に .c-slideshow が存在する (= TOP page) かつ PC (≥ 750px)
   *   挙動:
   *     1. 初期: section-header を 透過 + 白テキスト (CSS で適用済)
   *        announcement-bar の bottom に section-header の top を JS で動的設定
   *     2. window.scrollY > window.innerHeight (1 viewport) で
   *        .is-scrolled-past-hero クラスを section-header に付与 → 通常デザイン
   *     3. SP (≤ 749px) では何もしない (Dawn 既定の sticky-header 挙動維持)
   * ------------------------------------------------------------ */
  (function() {
    const init = () => {
      const slideshow = document.querySelector('.c-slideshow');
      const sectionHeader = document.querySelector('.shopify-section.section-header');
      const announcementBar = document.querySelector('.announcement-bar-section');
      if (!slideshow || !sectionHeader) return;

      const mql = window.matchMedia('(min-width: 750px)');

      const updateAnnouncementOffset = () => {
        if (!mql.matches) {
          sectionHeader.style.top = '';
          return;
        }
        if (announcementBar) {
          sectionHeader.style.top = announcementBar.offsetHeight + 'px';
        } else {
          sectionHeader.style.top = '0';
        }
      };

      const updateScrollState = () => {
        if (!mql.matches) {
          sectionHeader.classList.remove('is-scrolled-past-hero');
          return;
        }
        // announcement-bar は通常フロー → スクロール時に画面外に出る
        // section-header の top を「announcement-bar 下端 → スクロールアウト後は 0」に動的調整
        if (announcementBar) {
          if (window.scrollY > announcementBar.offsetHeight) {
            sectionHeader.style.top = '0';
          } else {
            sectionHeader.style.top = (announcementBar.offsetHeight - window.scrollY) + 'px';
          }
        }
        if (window.scrollY > window.innerHeight) {
          sectionHeader.classList.add('is-scrolled-past-hero');
        } else {
          sectionHeader.classList.remove('is-scrolled-past-hero');
        }
      };

      updateAnnouncementOffset();
      updateScrollState();
      window.addEventListener('scroll', updateScrollState, { passive: true });
      window.addEventListener('resize', () => {
        updateAnnouncementOffset();
        updateScrollState();
      });
      mql.addEventListener('change', () => {
        updateAnnouncementOffset();
        updateScrollState();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  /**
   * PC (≥750px) cascade パネルで「同時に 1 つの lvl3 パネルだけ開く」制御。
   * Dawn `MenuDrawer.onSummaryClick` は他の details を閉じないため、PC cascade では
   * 兄弟 lvl3 パネルが同じ left:100% 位置に重なって表示されてしまう。
   * 兄弟 details に [open] / .menu-opening が付いている場合は本リスナーで閉じる。
   * SP (<750px) では SP の slide-over UX を維持するため動作しない。
   */
  (function () {
    const initCascadeSibling = () => {
      const drawer = document.querySelector('header-drawer .c-drawer');
      if (!drawer) return;
      const mql = window.matchMedia('(min-width: 750px)');
      // すべての lvl2 details (孫を持つ親) を取得
      drawer.querySelectorAll('details.c-drawer__details').forEach((details) => {
        const summary = details.querySelector(':scope > summary');
        if (!summary) return;
        summary.addEventListener('click', () => {
          if (!mql.matches) return; // SP では何もしない
          // 同階層の兄弟 details を閉じる
          const parentList = details.parentElement?.parentElement; // li → ul
          if (!parentList) return;
          parentList.querySelectorAll(':scope > li > details.c-drawer__details').forEach((sibling) => {
            if (sibling === details) return;
            sibling.classList.remove('menu-opening');
            sibling.removeAttribute('open');
            const siblingSummary = sibling.querySelector(':scope > summary');
            if (siblingSummary) siblingSummary.setAttribute('aria-expanded', 'false');
          });
        });
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCascadeSibling);
    } else {
      initCascadeSibling();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
